import type { AdintelligenceSearchAdsSpendListParams } from "@similarweb/pro-api-client";

import type { ResponseError } from "app/services/fetchService";

import type { ISearchAdsSpendQueryParams } from "./types";

const BAD_REQUEST = 400;

/**
 * History is capped at a rolling window of months, since older spend has no exchange rates left to
 * convert it, and an interval reaching further back is rejected rather than trimmed. The window is a
 * backend constant, so the range is validated by what the endpoint answers rather than by a date here.
 */
export const isUnsupportedRange = (error: ResponseError | null): boolean => error?.status === BAD_REQUEST;

export const splitDomains = (keys: string): string[] =>
    keys
        .split(",")
        .map((domain) => domain.trim())
        .filter(Boolean);

export const toSearchAdsSpendListParams = ({
    country,
    from,
    to,
    keys,
    isWindow,
    webSource,
}: ISearchAdsSpendQueryParams): AdintelligenceSearchAdsSpendListParams => ({
    country,
    from,
    to,
    keys,
    isWindow,
    webSource,
});
